import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { shopService } from 'library/api/shopService';
import type { ProductDetail } from 'library/models/shop';

const usePromocode = () => {
	const { id = '' } = useParams();
	const [status, setStatus] = useState<string>('idle');
	const [code, setCode] = useState<string>('');
	const [product, setProduct] = useState({} as ProductDetail);

	useEffect(() => {
		const getPromo = async () => {
			setStatus('loading');
			try {
				const response = await shopService.getPromo();
				setCode(response.data.code);
			} catch (error) {}
			setStatus('loaded');
		};

		const getProduct = async () => {
			setStatus('loading');
			try {
				const response = await shopService.getProduct(id);
				setProduct(response.data);
			} catch (error) {}
			setStatus('loaded');
		};

		getPromo();
		id && getProduct();
	}, [id]);
	return { code, product, status };
};

export default usePromocode;
